import { Button, Form, FormGroup } from "react-bootstrap";
import { useState } from "react";
import CustomEditor from "../../elements/CustomEditor";
import { Faq, FaqTranslation } from "../../interfaces/Faq";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../../../utils/data/Languages";
import { Overlay } from "../../elements/Overlay";

export interface FaqAddProps {
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function FaqAdd(props: FaqAddProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');

    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        let error = false;
        let error_messages: string[] = [];

        if (!title.trim()) {
            error = true;
            error_messages.push(t("Title is required"));
        }

        if (error) {
            alert(error_messages.join('\n'));
        } else {
            // Create translations for all languages, copying English content to all
            const allTranslations: FaqTranslation[] = LANGUAGES.map(lang => ({
                lang: lang.code,
                title: title.trim(),
                body: body
            }));

            const newFaq: Faq = {
                _id: '',
                defaultLang: 'en',
                weight: parseInt(event.target.weight.value) || 0,
                translations: allTranslations
            };

            const requestOptionsPost = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newFaq)
            };

            fetch(import.meta.env.VITE_API_URL + '/v1/faq', requestOptionsPost)
                .then(response => {
                    if (response.status !== 200) {
                        console.error('Error response status:', response.status);
                        return response.text().then(text => {
                            console.error('Error response:', text);
                            throw new Error(`Server error: ${response.status}`);
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    props.submitCallback(data);
                })
                .catch(error => {
                    console.error('Error creating FAQ:', error);
                    alert(t("Error creating FAQ: ") + error.message);
                });
        }
    }

    const handleBodyChange = (data: string) => {
        setBody(data);
    }

    const doNothing = () => {

    }

    return(
        <Overlay title={t("Add new FAQ")} onClose={handleClose} className="admin-add-faq-container">
            <div className="faq-form-container">
                <Form onSubmit={ handleSubmit }>
                    <FormGroup className="title" controlId="title">
                        <Form.Label aria-required={ true }>{ t("Title") } (English)</Form.Label>
                        <Form.Control
                            type="text"
                            required={ true }
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder={ t("Enter a title") } />
                    </FormGroup>
                    <div className="field field-body">
                        <CustomEditor
                            change={ handleBodyChange }
                            changeFormatted={ doNothing }
                            data={ body }
                            formatted={ '' }
                            id="body"
                            label={ t("Body") + " (English)"}
                            npl={ false }
                            task_id={ '' }
                        />
                    </div>
                    <FormGroup className="weight" controlId="weight">
                        <Form.Label aria-required={ true }>{ t("Weight") }</Form.Label>
                        <Form.Control type="number" required={ true } name="weight"
                            defaultValue="0" placeholder={ t("Enter a weight") } />
                    </FormGroup>
                    <div className="help-text">
                        <small className="text-muted">
                            { t("You can add translations to other languages after creating the FAQ.") }
                        </small>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">{ t("Save") }</Button>
                    </div>
                </Form>
            </div>
        </Overlay>
    );
}
